<template>
    <div class="dx-field">
        <div class="dx-field-label hist-date-label">Менял после</div>
        <div class="dx-field-value">
            <DxDateBox
                v-model:value="conditions.beg"
                cssClass="texbox-dictonary"
                title="Когда менял"
                :accept-custom-value="false"
                :input-attr="{ 'aria-label': 'Date And Time' }"
                type="datetime"
                :show-clear-button="true"
                @valueChanged="setBegDate"
                @closed="setBegDate"
            />
        </div>
    </div>
    <div class="dx-field">
        <div class="dx-field-label hist-date-label">Менял до</div>
        <div class="dx-field-value">
            <DxDateBox
                v-model:value="conditions.end"
                title="Когда менял"
                :accept-custom-value="false"
                :input-attr="{ 'aria-label': 'Date And Time' }"
                type="datetime"
                :show-clear-button="true"
                @valueChanged="setEndDate"
                @closed="setEndDate"
            />
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';

import DxDateBox from 'devextreme-vue/date-box';

const conditions = inject('conditions');

</script>

<style scoped>
.hist-date-label {
    margin-bottom: 3px;
}
</style>
